<template>
  <div>
    <v-progress-linear
      indeterminate
      v-if="ui_show_spinner"
      color="yellow darken-2"
    ></v-progress-linear>
    <v-container v-if="ux_loaded">
      <v-layout>
        <v-flex xs12 sm6 offset-sm3>
          <p class="headline">
            Anmeldung zur Klausureinsicht ({{ user.email }})
          </p>

          (Anmeldung aktiv von {{ call_getGermanDate(start_date) }} bis
          {{ call_getGermanDate(end_date) }})
        </v-flex>
      </v-layout>

      <br />

      <v-layout v-if="ux_too_early">
        <v-flex xs12 sm6 offset-sm3>
          Die Anmeldung ist noch nicht aktiv.
        </v-flex>
      </v-layout>

      <v-layout v-if="ux_too_late">
        <v-flex xs12 sm6 offset-sm3>
          Die Anmeldefrist ist abgelaufen. Ihr Anmeldestatus:
        </v-flex>
      </v-layout>

      <v-layout v-if="!ux_too_late & !ux_too_early">
        <v-flex xs12 sm6 offset-sm3>
          Hier finden sie alle Prüfungen, die ich im Sommersemester 21
          angeboten habe. Bitte melden sie sich auch wieder ab, wenn sie nicht
          zur Einsicht erscheinen.
          <a
            href="https://the-technology-lab.gitbook.io/faq/aktuell-pruefungseinsicht"
            >Infos zur Organisation</a
          >
        </v-flex>
      </v-layout>

      <v-layout mt-3>
        <v-flex xs12 sm6 offset-sm3>
          <div v-for="m in module" :key="m.label" style="margin-top: -12px">
            <v-checkbox
              class="pb-0 mb-0"
              color="primary"
              v-model="selected"
              v-bind:disabled="ux_too_late || ux_too_early"
              v-bind:label="m.label"
              v-bind:value="m.value"
              @change="ux_dirty = true"
              hide-details
            ></v-checkbox>
          </div>
        </v-flex>
      </v-layout>
      <!-- Already has an account -->

      <v-layout style="margin-top: 10px; margin-left: -5px">
        <v-flex xs12 sm6 offset-sm3 v-if="!ux_too_late">
          <v-btn
            small
            color="primary"
            :disabled="!ux_dirty"
            v-on:click="uiEvent('save')"
          >
            Save
          </v-btn>
        </v-flex>
      </v-layout>
      <!-- Liste der Anmeldungen -->
      <v-layout>
        <v-flex xs12 sm6 offset-sm3 v-if="!ux_too_late" caption>
          Zum Anmelden Haken setzen und SAVE drücken. Nach dem Klicken auf
          "SAVE" sind Sie für alle markierten Prüfungen angemeldet. Zum Abmelden
          Haken entfernen und nochmal speichern. Letzte Änderung:
          {{ ux_last_changed }}<br />
        </v-flex>
      </v-layout>
      <!-- Liste der Anmeldungen -->
    </v-container>

    <v-divider></v-divider>
    <v-container v-if="ui_display && this.$store.getters.isAdmin">
      <v-layout>
        <v-flex headline xs12 sm6 offset-sm3>
          Admin Section (only visible for Admin)
        </v-flex>
      </v-layout>

      <v-layout>
        <v-flex mt-2 xs12 sm6 offset-sm3>
          <p>Ende der Anmeldung: {{ call_getGermanDate(end_date) }}</p>
          <p>Serverzeit: {{ call_getGermanDate(current_date) }}</p>
          <hr />
          <p>Ende der Anmeldung: {{ end_date }}</p>
          <p>Serverzeit: {{ current_date }}</p>
        </v-flex>
      </v-layout>
    </v-container>
    <!-- Container f�r SAP Antrag -->
  </div>
</template>


<script>
    import firebase from "firebase/compat/app";

    const firebaseFirestore = require('../myFirebase/firebaseFirestore.js')
    const firebaseList = require('./../store/firebaseList.js')
    import { Utils } from './../classes/Utils.js';
    import { FirebaseTable } from './table/FirebaseTable.js';
    import { config } from "./../classes/myConfig"

    export default {
        data() {
            return {

                tName: config.getSettings().tables.klausur_einsicht,
                fbTable: {},

                user : firebase.auth().currentUser,

                module: [
                    { label: 'BW/IB - Informationstechnologie', value: 'IT' },
                    { label: 'BW/IB - SAP (KM)', value: 'SAP-BW' },
                    { label: 'BW/IB - DSML', value: 'DSML' },
                    { label: 'WIF - SAP', value: 'SAP-WIF' },
                    { label: 'WIF - Mobile Business', value: 'MOBU' },
                    { label: 'MUF/MIB - SAP', value: 'SAP-MASTER' },                    
                ],

                is_active: true,
                can_save: false,
                ux_dirty: false,

                valid: false,
                ui_show_spinner: true,
                ui_display: false,

                ux_too_late: false,
                ux_too_early: false,
                ux_loaded: false,

                ux_save_disabled: true,
                ux_last_changed: '',

                selected: [],
                current_date: [],

                // An diesem Tag funktioniert die Anmeldung nicht mehr.
                // Diese Zeitangabe ist die tatsächliche Zeit (Bitte als Admin prüfen!)
                end_date: new Date('1970-01-01T00:00:00'),
                start_date: new Date('1970-01-01T00:00:00')
                //end_date: new Date()
            };
        },





        methods: {

            call_getGermanDate(date) { return Utils.getGermanDate(date) },

            async uiEvent(event) {

                let user = firebase.auth().currentUser;

                switch (event) {
                    case "back":
                        this.$router.push({ name: "Landing" });
                        break;

                    case "save":
                        this.ui_show_spinner = true;

                        // STEP 1:  Write text.
                        
                        var res = await this.fbTable.write_by_key( this.tName,  user.email,
                            {
                                selection: this.selected,
                                semester: config.getSettings().semester,
                                timestamp: firebase.firestore.FieldValue.serverTimestamp(),                                
                            });

                        if (res){
                        this.$store.commit("setSnackbarText", "Gespeichert.");
                        this.ux_last_changed = "gerade eben"
                        }
                        else 
                         {
                            this.$store.commit("setSnackbarText", "Fehler beim Speichern!");
                            this.ui_show_spinner = false;
                            return;
                        }


                        this.uxShowForm = false;
                        this.ui_show_spinner = false;
                        this.ux_dirty = false;
                        this.ux_save_disabled = true;

                        break;
                }


            },

            async db_read_selection( tName, email ){
            let entry = await this.fbTable.read_by_key( this.tName, email);
            if (!entry) {
                return []
            }
            else {
                return entry.selection;
            }
        },

        },

        

        async created() {

            this.fbTable = new FirebaseTable()
            

            // Return home, if 
            if (!this.is_active) {
                this.ui_show_spinner = false;
                return;
            }

            // Read the meta data and return, if there is an error
            let list = await this.fbTable.read_meta ( this.tName );           
            if (!list) {
                 this.ui_show_spinner = false;
                this.$store.commit("setSnackbarText", "Interner Fehler: Ungültige Liste");
                return;
            }


            // Read the selection...
            var user = firebase.auth().currentUser;    
            var line = await this.fbTable.read_by_key( this.tName, user.email);        
            this.selected = (!line) ? [] : line.selection;
            this.ux_last_changed = (!line) ?  "Bisher noch keine Auswahl getroffen." :  Utils.getGermanDate( line.timestamp.toDate())
            
            

            // Prepare the timing
            this.current_date = await firebaseFirestore.get_time();
            this.end_date = list.meta.valid_to.toDate();
            this.start_date = list.meta.valid_from.toDate();
            this.ux_too_late = (this.current_date > this.end_date);
            this.ux_too_early = (this.current_date < this.start_date);


            this.ui_display = true;
            this.ui_show_spinner = false;
            this.ux_loaded = true;

        },

       

        // Heavy nach jeder Eingabe uafgerufen!
        updated: function () {
            this.$nextTick(function () {

            })
        },

    };
</script>

<style scoped>
</style>
